module.exports = __webpack_public_path__ + "img/iconCalendar.5c6d5a66.svg";